import React, {useState, useRef} from 'react';
import {Link, useParams} from "react-router-dom";
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    v3Level9Session
} from "../../../services/metadata.service";

// name: display on preview top
// key: column# of excel sheet
// json_key: key for posting data to api
// key: column# of excel sheet (0-based) for "Level9 (Session)" sheet of DQ ClassARC v8.0
const columns = [
    {name: 'Session#', key: 0, json_key: 'session_no', data_key: 'session_no'},
    {name: 'Full Name', key: 1, json_key: 'full_name', data_key: 'full_name'},
    {name: 'Name (Act)', key: 2, json_key: 'name_act', data_key: 'name_act'},
    {name: 'Definition', key: 3, json_key: 'definition', data_key: 'definition'},
    {name: 'KSAB Dimension', key: 4, json_key: 'level9_ksab_dimensions', data_key: 'level9_ksab_dimensions'},
    {name: 'Unit#', key: 5, json_key: 'unit_no', data_key: 'unit_no'},
    {name: 'Unit Type', key: 6, json_key: 'unit_type', data_key: 'unit_type'},
    {name: 'DQCO#', key: 7, json_key: 'dqco_no', data_key: 'dqco_no'},
    {name: 'DQC#', key: 8, json_key: 'dqc_no', data_key: 'dqc_no'},
    {name: 'DQM#', key: 9, json_key: 'dqm_no', data_key: 'dqm_no'},
    {name: 'DQA#', key: 10, json_key: 'dqa_no', data_key: 'dqa_no'},
]

// v8.0 new columns are optional in the edit form (the modal defaults every field to required)
const fieldConfig = {
    name_act: { required: false },
    unit_type: { required: false },
}

const tableCols = [
    {
        label: 'Session#',
        field: 'session_no', width: 150
    },
    {
        label: 'Full Name',
        field: 'full_name', width: 150
    },
    {
        label: 'Name (Act)',
        field: 'name_act', width: 150
    },
    {
        label: 'Definition',
        field: 'definition', sort: 'disabled', width: 150
    },
    {
        label: 'KSAB Dimension',
        field: 'level9_ksab_dimensions', sort: 'disabled', width: 200
    },
    {
        label: 'Unit#',
        field: 'unit_no', width: 120
    },
    {
        label: 'Unit Type',
        field: 'unit_type', width: 150
    },
    {
        label: 'DQCO#',
        field: 'dqco_no', width: 120
    },
    {
        label: 'DQA#',
        field: 'dqa_no', width: 120
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]


export default function Level9SessionPage() {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const [serverPage, setServerPage] = useState(1);
    const [serverLimit, setServerLimit] = useState(10);
    const [serverTotal, setServerTotal] = useState(0);
    const [serverTotalPages, setServerTotalPages] = useState(1);
    const [serverSearch, setServerSearch] = useState(search_query || '');
    const [debouncedSearch, setDebouncedSearch] = useState(search_query || '');
    const debounceTimer = useRef(null);

    const handleServerSearchChange = (newSearch) => {
        setServerSearch(newSearch);
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => {
            setDebouncedSearch(newSearch);
            setServerPage(1);
        }, 400);
    };

    const fetchPage = async (page, limit, search) => {
        const result = await v3Level9Session.listData(page, limit, search);
        if (result && result.data) {
            const { total, page: pg, limit: lm, total_pages } = result.data;
            const clampedPage = total_pages > 0 && pg > total_pages ? total_pages : pg;
            setServerPage(clampedPage || 1);
            setServerLimit(lm || limit);
            setServerTotal(total || 0);
            setServerTotalPages(total_pages || 1);
        }
        return result;
    };

    const handleServerPageChange = (newPage) => { setServerPage(newPage); };
    const handleServerLimitChange = (newLimit) => { setServerPage(1); setServerLimit(newLimit); };
    const paginatedListAPI = async () => fetchPage(serverPage, serverLimit, debouncedSearch);

    const table_row__additional_rendering = (row) => {
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Level9 Session'}
            modal_title={'Level9 Session - Data Preview'}
            sheet_name={'Level9 (Session)'}
            columns={columns}
            tableCols={tableCols}
            fieldConfig={fieldConfig}
            chunkSize={2000}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={paginatedListAPI}
            postAPI={v3Level9Session.postData}
            deleteAPI={v3Level9Session.deleteEntity}
            updateAPI={v3Level9Session.updateEntity}
            preRemoveAPI={v3Level9Session.preRemoveCheck}
            serverSidePagination={true}
            serverPage={serverPage}
            serverLimit={serverLimit}
            serverTotal={serverTotal}
            serverTotalPages={serverTotalPages}
            onServerPageChange={handleServerPageChange}
            onServerLimitChange={handleServerLimitChange}
            serverSideSearch={true}
            serverSearch={serverSearch}
            onServerSearchChange={handleServerSearchChange}
            debouncedSearch={debouncedSearch}
        />
    );
}
